import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../contexts/AdminAuthContext";
import { SquaresFour, UsersThree, Package, ChatCircleText, Target, SignOut, FileText, PenNib } from "@phosphor-icons/react";

const ITEMS = [
  { key: "dashboard", label: "Dashboard", icon: SquaresFour },
  { key: "leads", label: "Leads", icon: Target },
  { key: "packages", label: "Packages", icon: Package },
  { key: "clients", label: "Clients", icon: UsersThree },
  { key: "messages", label: "Messages", icon: ChatCircleText },
  { key: "resources", label: "Resources", icon: FileText },
  { key: "website", label: "Website Editor", icon: PenNib },
];

export default function AdminSidebar({ section, setSection, adminName }) {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin-login");
  };

  return (
    <aside className="w-20 lg:w-64 bg-[#141414] border-r border-[#27272A] flex flex-col shrink-0">
      <div className="p-6 hidden lg:block">
        <p className="font-heading uppercase tracking-tight text-xl text-white">
          EXIST <span className="text-[#D4AF37]">FIT</span>
        </p>
        <p className="text-xs text-[#71717A] mt-1">{adminName || "Coach"}</p>
      </div>
      <nav className="flex-1 px-3 space-y-1 mt-4 lg:mt-0">
        {ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.key}
              data-testid={`admin-nav-${item.key}`}
              onClick={() => setSection(item.key)}
              className={`w-full flex items-center justify-center lg:justify-start gap-3 px-3 py-3 rounded-xl text-sm transition-colors ${
                section === item.key ? "bg-[#D4AF37] text-black font-semibold" : "text-[#A1A1AA] hover:bg-white/5 hover:text-white"
              }`}
            >
              <Icon size={20} weight={section === item.key ? "fill" : "regular"} />
              <span className="hidden lg:inline">{item.label}</span>
            </button>
          );
        })}
      </nav>
      <div className="p-3">
        <button
          data-testid="admin-logout-button"
          onClick={handleLogout}
          className="w-full flex items-center justify-center lg:justify-start gap-3 px-3 py-3 rounded-xl text-sm text-[#A1A1AA] hover:bg-white/5 hover:text-white transition-colors"
        >
          <SignOut size={20} /> <span className="hidden lg:inline">Log Out</span>
        </button>
      </div>
    </aside>
  );
}
